export default __webpack_public_path__ + "static/media/pg13.d526571d.png";